<div class="content-container">
    <div class="content-area">
        <h3>Здравейте, {{tenant.name}}</h3>
        <!-- <ul>
          <li>Start by clicking Fork in the toolbar above.</li>
          <li>Implement the problem in the new editor.</li>
          <li>Save the result, and share the url in a GitHub or StackOverflow issue.</li>
        </ul> -->
    </div>
</div>